import React from "react";
import GlobalToolAccordion from "../GlobalToolAccordion";
import DisplayVariable from "./DisplayVariable";
import AddVariable from "./AddVariable";
import UpdateVariable from "./UpdateVariable";
import type { UpdateVariableProps } from "./UpdateVariable";

const emptyVariable: UpdateVariableProps["variable"] = {
  title: "",
  notes: "",
  type: "content",
  status: "required",
  variable_type: "",
  variable_complex_type: "",
  example: "",
  image: "",
};

// SCRUM-2118: the accordion lives in GlobalToolAccordion; this screen is its configuration.
// AddVariable takes no back handler, as before.
const VariableContainer = () => (
  <GlobalToolAccordion<UpdateVariableProps["variable"]>
    headerName="Variables"
    listTitle="Available variables"
    readOnlyListTitle="Available variables"
    noun="variable"
    titleOf={(variable) => variable.title}
    emptyElem={emptyVariable}
    renderList={(handleUpdate) => <DisplayVariable handleUpdate={handleUpdate} />}
    renderCreate={() => <AddVariable />}
    renderUpdate={(variable, back) => <UpdateVariable variable={variable} switchToVariableListHandler={back} />}
  />
);

export default VariableContainer;
